// extracted by mini-css-extract-plugin
module.exports = {"title":"index_title__3XXS0","value":"index_value__1Vze-"};